// Packages
import { KiteDialog } from '@kite/react-kite';

// Components

// Hooks

// Utils

// Types

// Styles
import './ConfirmationDialog.scss';

/** Update this description, which will appear in the Storybook documentation */

interface IConfirmationDialogProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  title?: string;
  message?: string;
}

const ConfirmationDialog = ({
  isOpen,
  onConfirm,
  onCancel,
  title = 'Confirm Approval',
  message = 'Are you sure you want to approve this document without review?',
}: IConfirmationDialogProps) => {
  return (
    <KiteDialog
      id="approve-confirmation"
      open={isOpen}
      title={title}
      icon="ki-caution-circle-f"
      onClose={onCancel}
      secondaryBtnLabel="Yes"
      onSecondaryBtnClick={onConfirm}
      tertiaryBtnLabel="No"
      onTertiaryBtnClick={onCancel}
    >
      <div className="kite-dialog__content-group">{message}</div>
    </KiteDialog>
  );
};

export default ConfirmationDialog;
